<template lang="pug">
  window(title="SQL", :zGroup="1", :resizable="true", :width=480, :height=360, :closeButton="true", :isOpen.sync="isOpen", :minWidth=200, :minHeight=200, @open="windowOpened = true")
    sql-editor(v-if="windowOpened", :module="module")
</template>


<script lang="ts">
import { Vue, Component, Prop } from "vue-property-decorator";
import { CasModule } from "@/modules/ssp_database/CasModule";
import Loading from '@/components/Loading.vue'

@Component({
  components: {
    SqlEditor: () => ({
      component: import('./SqlEditor/index.vue'),
      loading: Loading,
      delay: 0,
    }) as any,
  },
})
export default class extends Vue {
  @Prop({ required: true })
  module!: CasModule

  windowOpened = false

  mounted() {
    this.windowOpened = this.module.showSqlEditor
  }

  get isOpen() {
    return this.module.showSqlEditor
  }

  set isOpen(isOpen: boolean) {
    this.module.showSqlEditor = isOpen
  }
}
</script>